import React from "react";
import ConveniosYearPage from "./ConveniosYearPage";
import { convenios2014 } from "../../../../data/Convenios/dataConvenios";

const Convenios2014 = () => <ConveniosYearPage year={2014} data={convenios2014} />;

export default Convenios2014;